// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"de4f5302","478":"106cbe54"}[chunkId] + ".chunk.js";
};